import { track } from 'actions/analyticsActions';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'utils/classNames';
import { analyticsTypes } from '../../../constants/analytics';
import './anchor.css';

const { LINK_CLICK } = analyticsTypes;

export interface AnchorInterface {
  to?: string | {};
  href?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  target?: string;
  className?: string;
  external?: boolean;
  children?: string | JSX.Element | JSX.Element[];
  style?: any;
  disabled?: boolean;
  track?: (data: { event: string; eventType: string }) => void;
}

const Anchor: React.StatelessComponent<AnchorInterface> = ({
  external = false,
  disabled = false,
  track,
  ...props
}): JSX.Element => {
  const handleOnClick = event => {
    if (track) {
      track({
        event: typeof props.children === 'string' ? props.children : props.href,
        eventType: LINK_CLICK,
      });
    }

    if (props.onClick) {
      props.onClick(event);
    }
  };

  return external ? (
    <a
      href={disabled ? null : props.href}
      target={props.target}
      className={classNames({
        disabled,
        [props.className]: !!props.className,
      })}
      onClick={e => handleOnClick(e)}
    >
      {props.children}
    </a>
  ) : (
    <Link
      {...props}
      href={disabled ? null : props.href}
      className={classNames({
        disabled,
        [props.className]: !!props.className,
      })}
      onClick={e => handleOnClick(e)}
    >
      {props.children}
    </Link>
  );
};

const mapDispatchToProps = dispatch => ({
  track: data => dispatch(track(data)),
});

export const TestAnchorComponent = Anchor;

export default connect(null, mapDispatchToProps)(Anchor);
